<div class="c-page-header" id="divPageHeader">
  <h1 id="h1Title"><mat-icon id="divDashboard">dashboard</mat-icon>{{title | translate}}</h1>
</div>
